<template>
  <md-field>
    <md-select v-model="selectedMonth">
      <md-option v-for="m in months" :key="m.value" :value="m.value">{{
        m.text
      }}</md-option>
    </md-select>
  </md-field>
</template>
<script>
import moment from 'moment'

/**
 * 月選択ドロップダウン
 * 指定された開始日が属する月から終了日が属する月までを持つドロップダウンを作成します。
 */
export default {
  props: {
    /**
     * この日付が属する月からリストを作成する８
     */
    min: {
      required: true,
      type: String,
      validator(value) {
        return new RegExp(/^\d{8}$/g).test(value)
      },
    },
    /**
     * この日付が属する月までリストを作成する
     */
    max: {
      required: true,
      type: String,
      validator(value) {
        return new RegExp(/^\d{8}$/g).test(value)
      },
    },
    /**
     * 選択されている月
     */
    value: {
      type: String,
      validator(value) {
        return new RegExp(/^\d{6}$/g).test(value)
      },
    },
  },
  computed: {
    selectedMonth: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value + '01')
      },
    },
    /**
     * 降順に月リストを作成する。表示テキストは「yyyy年mm月」。
     * minが月の初日ではない場合、「yyyy年mm月（ddから）」と表示する。
     * maxが月の最終日ではない場合、「yyyy年mm月（ddまで）」と表示する。
     */
    months() {
      const from = moment(this.min, 'YYYYMM')
      const to = moment(this.max, 'YYYYMM')
      const diff = to.diff(from, 'months') + 1

      if (diff < 0) {
        throw new Error('Invalid dateFrom and dateTo')
      }

      let current = to
      const months = []

      for (let i = 0; i < diff; i++) {
        months.push({
          value: current.format('YYYYMM'),
          text: current.format('YYYY年M月'),
        })
        current = current.subtract(1, 'months')
      }

      // 初月と最終月には日付を入れる（1ヶ月丸々ある保証がないので）
      // TODO リファクタリング
      const startDateOfMinMonth = moment(this.min, 'YYYYMMDD')
        .startOf('month')
        .get('date')
      const dateOfMin = moment(this.min, 'YYYYMMDD').get('date')
      const endDateOfMinMonth = moment(this.max, 'YYYYMMDD')
        .endOf('month')
        .get('date')
      const dateOfMax = moment(this.max, 'YYYYMMDD').get('date')

      if (startDateOfMinMonth !== dateOfMin) {
        const firstMonth = months[months.length - 1]
        firstMonth.text = `${firstMonth.text}（${dateOfMin}日から）`
      }
      if (endDateOfMinMonth !== dateOfMax) {
        const lastMonth = months[0]
        lastMonth.text = `${lastMonth.text}（${dateOfMax}日まで）`
      }

      return months
    },
  },
}
</script>
